import { authService } from "@/services/auth";
import { api } from "@api/axiosInstance";
import { resetCategory } from "@app-redux/slices/categorySlice";
import { resetFilters } from "@app-redux/slices/filtersSlice";
import { resetProfileList } from "@app-redux/slices/profileListSlice";
import { resetProfile } from "@app-redux/slices/profileSlice";
import { resetUserData, setUnauthorized } from "@app-redux/slices/userDataSlice";
import { resetOpportunity } from "@app-redux/slices/opportunitySlice";
import { useAppDispatch } from "@app-redux/store";
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const logout = async () => {
    dispatch(resetUserData());
    dispatch(resetProfileList());
    dispatch(resetProfile());
    dispatch(resetFilters());
    dispatch(resetCategory());
    dispatch(resetOpportunity());
    await instance.logoutRedirect();
  };

  useEffect(() => {
    const request = api.interceptors.request.use(
      async (config) => {
        const token = await authService.getAccessToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const response = api.interceptors.response.use(
      (res) => res,
      async (error) => {
        if (error.response?.status === 401) {
          // Token was invalid/expired and silent refresh failed.
          // The auth guard in App.tsx handles re-authentication.
          await logout();
        }
        if (error.response?.status === 403) {
          dispatch(setUnauthorized());
        }
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.response.eject(response);
      api.interceptors.request.eject(request);
    };
  }, []);
};
